import { globalStyles } from "shared/constants";
const { display, flex } = globalStyles;

const filterStyles = {
  drawerPaper: {
    height: "100%",
    width: "480px",
  },
  filterWrapper: {
    padding: "14px",
  },
  input: {
    // width: "140px",
    marginRight: "12px",
    backgroundColor: "grey.100",
  },
  filterButton: {
    height: "46px !important",
    minWidth: "36px !important",
    borderRadius: 8,
    padding: "5px 10px",
  },
  filterContainer: {
    marginBottom: 2,
    width: "100%",
    ...display.flex,
    ...flex.align.center,
  },
  filterHeading: {
    padding: "14px",
    backgroundColor: "grey.100",
    marginBottom: "32px",
  },
  clearbutton: {
    width: "100%",
    ...flex.justify.end,
  },
  confirmBtn: {
    position: "absolute",
    right: "16px",
    bottom: "16px",
  },
};

export default filterStyles;
